import React from "react";
import { BaseControl, ControlProps } from "./BaseControl";
import { QuestionModel } from "../../models/QuestionModel";
import ErrorRenderer from "../shared/ErrorRenderer";
import { QuestionType } from "../../models/enums/QuestionType";
import { ValidationResultModel } from "../../models/ValidationResultModel";
import { ValidationBuilder } from "../../models/builders/ValidationBuilder";
import { ValidationOptionsModel } from "../../models/ValidationOptionsModel";

export class UndefinedControl extends BaseControl<any, any> {
    initializeQuestion(question: QuestionModel, props: ControlProps): void {}

    renderQuestion(question: QuestionModel) {
        return (
            <ErrorRenderer error={`No renderer for question type ${QuestionType[question.type]}`} />
        );
    }

    validate(options?: ValidationOptionsModel): ValidationResultModel {
        return new ValidationBuilder().build();
    }
}
